/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';
import RichTextEditor from 'Components/UI/RichTextEditor';

const hiddenFieldNames = ['meetingId'];

export const AdvisorNoteModalItemOverride = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .override({ name: name => hiddenFieldNames.includes(name) }, { hidden: true })
  .nameOverride('meetingId', { hidden: true })
  .nameOverride('meetingId', { hidden: true })
  .nameOverride('householdId', { ordinal: 1 })
  .nameOverride('noteType', { ordinal: 2 })
  .nameOverride('content', {
    _component: () => RichTextEditor,
    _customProps: {
      size: 'lg',
    },
    ordinal: 3,
  });
